import fetchOrganizations from '../endpoint-requests/organization/fetchOrganizations'
import getAllSites from '../endpoint-requests/site/fetchSites'
import getSiteConfiguration from '../endpoint-requests/site/getSiteConfiguration'
import fetchDailyMachineUsages from '../endpoint-requests/usage/fetchDailyMachineUsages'
import {
    avgScrubTimeFailure,
    avgScrubTimeStart,
    avgScrubTimeSuccess,
    avgWashScoreFailure,
    avgWashScoreStart,
    avgWashScoreSuccess,
    dailyMachineUsagesFailure,
    dailyMachineUsagesStart,
    dailyMachineUsagesSuccess,
    handWashMovementsFailure,
    handWashMovementsStart,
    handWashMovementsSuccess,
    handWashValuesFailure,
    handWashValuesStart,
    handWashValuesSuccess,
    totalWashCountFailure,
    totalWashCountStart,
    totalWashCountSuccess,
    washDatesSuccess,
    washValuesSuccess
} from './dailyMachineUsagesRedux'
import {
    dateRangeFailure,
    dateRangeStart,
    dateRangeSuccess,
    fromDateFailure,
    fromDateStart,
    fromDateSuccess,
    toDateFailure,
    toDateStart,
    toDateSuccess,
} from './datesReducer'
import { minWashCountStart, minWashCountSuccess } from './minWashCountReducer'
import fetchChampionsResults from '../endpoint-requests/champions-results/createChampionsResults'
import fetchHandsRecognition from '../endpoint-requests/hands-recognition/fetchHandsRecognition'
import { sortData } from './SortData.js'

import {
    currentOrganizationFailure,
    currentOrganizationIdFailure,
    currentOrganizationIdStart,
    currentOrganizationIdSuccess,
    currentOrganizationStart,
    currentOrganizationSuccess,
    getOrganizationsFailure,
    getOrganizationsStart,
    getOrganizationsSuccess,
} from './organizationsRedux'
import {
    autoRefreshTimeFailure,
    autoRefreshTimeStart,
    autoRefreshTimeSuccess,
    currentFromSuccess,
    currentShiftFailure,
    currentShiftStart,
    currentShiftSuccess,
    currentToSuccess,
    previousFromSuccess,
    previousShiftFailure,
    previousShiftStart,
    previousShiftSuccess,
    previousToSuccess,
    shiftConfigurationDataFailure,
    shiftConfigurationDataStart,
    shiftConfigurationDataSuccess,
    shiftNumberFailure,
    shiftNumberStart,
    shiftNumberSuccess
} from './shiftsReducer'
import {
    currentSiteFailure,
    currentSiteIdFailure,
    currentSiteIdStart,
    currentSiteIdSuccess,
    currentSitesFailure,
    currentSitesIdsFailure,
    currentSitesIdsStart,
    currentSitesIdsSuccess,
    currentSitesNamesFailure,
    currentSitesNamesStart,
    currentSitesNamesSuccess,
    currentSitesStart,
    currentSitesSuccess,
    currentSiteStart,
    currentSiteSuccess,
    siteCampaignActiveFailure,
    siteCampaignActiveStart,
    siteCampaignActiveSuccess,
    siteMachinesIdsFailure,
    siteMachinesIdsStart,
    siteMachinesIdsSuccess,
    sitesMachinesIdsFailure,
    sitesMachinesIdsStart,
    sitesMachinesIdsSuccess,
    userSitesFailure,
    userSitesStart,
    userSitesSuccess
} from './sitesRedux'
import { userFailure, userStart, userSuccess } from './userReducer'
import { pagesFailure, pagesStart, pagesSuccess } from './pagesReducer'
import { HANDS_ICON_NAMES_LOWERCASE, HANDS_RECOGNITION_KEYS } from '../shared/hands-recognition/handsRecognitionNames'
import {
    championsFailure,
    championsStart,
    championsSuccess,
    currentChampionFailure,
    currentChampionStart,
    currentChampionSuccess,
    previousChampionFailure,
    previousChampionStart,
    previousChampionSuccess
} from './championsRedux'
import { loaderSuccess } from './loaderReducer'
import {
    currentAvgWashScoreFailure,
    currentAvgWashScoreStart,
    currentAvgWashScoreSuccess,
    currentFailedCountFailure,
    currentFailedCountStart,
    currentFailedCountSuccess,
    currentShiftResultsFailure,
    currentShiftResultsStart,
    currentShiftResultsSuccess,
    currentWashCountFailure,
    currentWashCountStart,
    currentWashCountSuccess,
    currentWashLeftSuccessAuto
} from './currentShiftResultsReducer'
import {
    previousAvgWashScoreFailure,
    previousAvgWashScoreStart,
    previousAvgWashScoreSuccess,
    previousFailedCountFailure,
    previousFailedCountStart,
    previousFailedCountSuccess,
    previousShiftResultsFailure,
    previousShiftResultsStart,
    previousShiftResultsSuccess,
    previousWashCountFailure,
    previousWashCountStart,
    previousWashCountSuccess,
    previousWashLeftSuccessAuto
} from './previousShiftResultsReducer'
import { unitCampaignActiveFailure, unitCampaignActiveStart, unitCampaignActiveSuccess } from './unitConfigurationReducer'
import { fetchDailyWashesMultiMachines } from '../endpoint-requests/daily-wash/fetchDailyWashesMultiMachines'
import { dailyWashesFailure, dailyWashesStart, dailyWashesSuccess, } from './dailyWashesReducer'
import { clientLogoSuccess, importantImageUploadSuccess } from './shiftImagesReducer'
import { fetchShiftConfiguration } from '../endpoint-requests/shift-configuration/getShiftConfiguration'
import { createShiftConfiguration } from '../endpoint-requests/shift-configuration/createShiftConfiguration'
import { getReportVersion } from '../endpoint-requests/reports/getReportVersion'

//Get all organizations
export const getOrganizations = async (dispatch) => {
    dispatch(getOrganizationsStart())

    try {
        const organizationData = await fetchOrganizations()
        if (organizationData.length > 0) {
            organizationData.sort(sortData)
            dispatch(getOrganizationsSuccess(organizationData))
            return organizationData
        } else {
            dispatch(getOrganizationsFailure());
        }
    } catch (error) {
        dispatch(getOrganizationsFailure());
    }
};


//Get current organization and organizationId
export const getCurrentOrganization = async (dispatch, orgName, orgId) => {
    if (orgName === "" || orgId === "") {
        dispatch(currentOrganizationFailure())
        dispatch(currentOrganizationIdFailure())
    }
    dispatch(currentOrganizationStart());
    dispatch(currentOrganizationIdStart());
    dispatch(currentOrganizationSuccess(orgName));

    dispatch(currentOrganizationIdSuccess(orgId));
};


//Get all user's sites
export const getSites = async (dispatch, organizationId,) => {
    dispatch(userSitesStart());

    try {
        const sitesData = await getAllSites()
        const filteredSites = sitesData.filter(site => site.organizationId === organizationId)

        if (filteredSites.length > 0) {
            filteredSites.sort(sortData)
            dispatch(userSitesSuccess(filteredSites));

        }
        if (filteredSites.length === 0) {

            dispatch(userSitesSuccess([]));

        }

        return filteredSites;
    } catch (error) {
        dispatch(userSitesFailure());
    }
};


//Get current site and siteId
export const getCurrentSite = async (dispatch, siteName, siteId, siteMachinesIds) => {
    if (siteName === "" || siteId === "") {
        dispatch(currentSiteFailure())
        dispatch(currentSiteIdFailure())
        dispatch(siteMachinesIdsFailure())

    }
    dispatch(currentSiteStart());
    dispatch(currentSiteIdStart());
    dispatch(siteMachinesIdsStart())

    dispatch(currentSiteSuccess(siteName));

    dispatch(currentSiteIdSuccess(siteId));
    dispatch(siteMachinesIdsSuccess(siteMachinesIds))

};

//Get current site and siteId
export const getCurrentSites = async (dispatch, currentSitesArray, currentSitesNamesArray, currentSitesIdsArray, currentSitesMachinesIds) => {
    if (currentSitesNamesArray.length === 0 || currentSitesIdsArray.length === 0) {
        dispatch(currentSitesFailure())
        dispatch(currentSitesNamesFailure())
        dispatch(currentSitesIdsFailure())
        dispatch(sitesMachinesIdsFailure())

    }
    dispatch(currentSitesStart());
    dispatch(currentSitesNamesStart());
    dispatch(currentSitesIdsStart());
    dispatch(sitesMachinesIdsStart())

    dispatch(currentSitesSuccess(currentSitesArray));
    dispatch(currentSitesNamesSuccess(currentSitesNamesArray));
    dispatch(currentSitesIdsSuccess(currentSitesIdsArray));
    dispatch(sitesMachinesIdsSuccess(currentSitesMachinesIds))

};


//Get current site campaign active
export const getSiteCampaignActive = async (dispatch, siteId) => {
    if (siteId === "") {
        dispatch(siteCampaignActiveFailure())
    }
    dispatch(siteCampaignActiveStart());
    try {
        const { isCampaignActive } = await getSiteConfiguration(siteId)
        dispatch(siteCampaignActiveSuccess(isCampaignActive));
    } catch (error) {
        dispatch(siteCampaignActiveFailure())

    }

};

//Get unit campaign active
export const getUnitCampaignActive = async (dispatch, siteId) => {
    dispatch(unitCampaignActiveStart());
    if (siteId === "" || siteId === null) {
        dispatch(unitCampaignActiveSuccess(null));

    }
    else {

        try {
            const { isCampaignActive } = await getSiteConfiguration(siteId)
            dispatch(unitCampaignActiveSuccess(isCampaignActive));
        } catch (error) {
            dispatch(unitCampaignActiveFailure())

        }
    }

};

//Get fromDate and toDate
export const getFromToDate = async (dispatch, dateRange, fromDate, toDate) => {
    if (fromDate === "" || toDate === "") {
        dispatch(fromDateFailure())
        dispatch(toDateFailure())
        dispatch(dateRangeFailure())

    }
    dispatch(fromDateStart());
    dispatch(toDateStart());
    dispatch(dateRangeStart())
    dispatch(dateRangeSuccess(dateRange));
    dispatch(fromDateSuccess(fromDate));
    dispatch(toDateSuccess(toDate));
};

//Get user
export const getUser = async (dispatch, user) => {
    if (!user) {
        dispatch(userFailure())
    }
    dispatch(userStart())
    dispatch(userSuccess(user))
}

//Get pages
export const getPages = async (dispatch, pages) => {
    if (!pages) {
        dispatch(pagesFailure())
    }
    dispatch(pagesStart())
    dispatch(pagesSuccess(pages))
}


//get shifts
export const getShifts = async (
    dispatch, shiftNumber, previousShift,
    currentShift, currentFrom, currentTo,
    previousFrom, previousTo, siteMachinesIds,
    minWashCount, currentSiteId) => {


    const ctFrom = currentFrom != "" && new Date(currentFrom).toISOString()
    const ctTo = currentTo != "" && (new Date(new Date(new Date(currentTo).toISOString()) - 1000)).toISOString() //subtracting one sec from to hour
    const prFrom = previousFrom != "" && new Date(previousFrom).toISOString()
    const prTo = previousTo != "" && (new Date(new Date(new Date(previousTo).toISOString()) - 1000)).toISOString() //subtracting one sec from to hour

    if (previousShift === '' || currentShift === '') {
        dispatch(shiftNumberFailure())
        dispatch(previousShiftFailure())
        dispatch(currentShiftFailure());
    }

    dispatch(shiftNumberStart());
    dispatch(previousShiftStart());
    dispatch(currentShiftStart());


    dispatch(shiftNumberSuccess(shiftNumber));
    dispatch(previousShiftSuccess(previousShift));
    dispatch(currentShiftSuccess(currentShift));

    dispatch(currentFromSuccess(ctFrom));
    dispatch(currentToSuccess(ctTo));
    dispatch(previousFromSuccess(prFrom));
    dispatch(previousToSuccess(prTo));

    if (previousFrom !== "" && previousTo !== "") {
        getPreviousDailyMachineUsages(dispatch, prFrom, prTo, siteMachinesIds, minWashCount)
        getPreviousChampion(dispatch, currentSiteId, prFrom, prTo)
    }
    if (currentFrom !== "" && currentTo !== "") {
        getCurrentDailyMachineUsages(dispatch, ctFrom, ctTo, siteMachinesIds, minWashCount)
        getCurrentChampion(dispatch, currentSiteId, ctFrom, ctTo)
    }
};


//Get minWashCount
export const getMinWashCount = async (dispatch, minWashCount) => {

    if (minWashCount === "") {
        dispatch(minWashCountSuccess(""));
    }
    dispatch(minWashCountStart());

    dispatch(minWashCountSuccess(minWashCount));

};

//round 
const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

//washCount
const getWashCount = (dispatch, data) => {
    let washCount = 0
    if (data.length !== 0) {

        dispatch(totalWashCountStart())
        let array = data.map((i) => {
            return i.washCount
        })
        washCount = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        dispatch(totalWashCountSuccess(washCount))
        return washCount
    }
    if (data.length === 0) {
        dispatch(totalWashCountStart())
        dispatch(totalWashCountSuccess(0))

    }

}



//currentShiftWashCount
const currentShiftWashCount = (dispatch, data) => {
    let washCount = 0

    if (data.length !== 0) {

        dispatch(currentWashCountStart())
        let array = data.map((i) => {
            return i.washCount
        })
        washCount = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        dispatch(currentWashCountSuccess(washCount))
        return washCount

    }
    if (data.length === 0) {
        dispatch(currentWashCountStart())
        dispatch(currentWashCountSuccess(0))

    }

}


//currentShiftFailedWashCount
const currentShiftFailedWashCount = (dispatch, data) => {
    if (data.length !== 0) {

        dispatch(currentFailedCountStart())
        let array = data.map((i) => {
            return i.washFailedCount
        })
        let washFailedSum = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        dispatch(currentFailedCountSuccess(washFailedSum))
    }
    if (data.length === 0) {
        dispatch(currentFailedCountStart())
        dispatch(currentFailedCountSuccess(0))

    }

}


//previousShiftWashCount
const previousShiftWashCount = (dispatch, data) => {
    let washCount = 0

    if (data.length !== 0) {

        dispatch(previousWashCountStart())
        let array = data.map((i) => {
            return i.washCount
        })
        washCount = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        dispatch(previousWashCountSuccess(washCount))
        return washCount
    }
    if (data.length === 0) {
        dispatch(previousWashCountStart())
        dispatch(previousWashCountSuccess(0))

    }

}

//previousShiftFailedWashCount
const previousShiftFailedWashCount = (dispatch, data) => {
    if (data.length !== 0) {

        dispatch(previousFailedCountStart())
        let array = data.map((i) => {
            return i.washFailedCount
        })
        let washFailedSum = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        dispatch(previousFailedCountSuccess(washFailedSum))
    }
    if (data.length === 0) {
        dispatch(previousFailedCountStart())
        dispatch(previousFailedCountSuccess(0))

    }

}


//wash percentage
const getWashPercentage = (dispatch, data, washCount) => {
    if (data.length !== 0) {
        dispatch(avgWashScoreStart())
        let array = data.map((i) => {
            let productValue = i.washCount * i.washAveragePercentage
            return productValue
        })
        let sum = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        let percentResult = sum / washCount
        dispatch(avgWashScoreSuccess((round(percentResult, 1))))
    }
    if (data.length === 0) {
        dispatch(avgWashScoreStart())
        dispatch(avgWashScoreSuccess(0))

    }

}

//currentShiftWashPercentage
const currentShiftWashPercentage = (dispatch, data, washCount) => {
    if (data.length !== 0) {
        dispatch(currentAvgWashScoreStart())
        let array = data.map((i) => {
            let productValue = i.washCount * i.washAveragePercentage
            return productValue
        })
        let sum = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        let percentResult = sum / washCount
        dispatch(currentAvgWashScoreSuccess((round(percentResult, 1))))
    }
    if (data.length === 0) {
        dispatch(currentAvgWashScoreStart())
        dispatch(currentAvgWashScoreSuccess(0))

    }
    else {
        dispatch(currentAvgWashScoreFailure())
    }
}

//previousShiftWashPercentage
const previousShiftWashPercentage = (dispatch, data, washCount) => {
    if (data.length !== 0) {
        dispatch(previousAvgWashScoreStart())
        let array = data.map((i) => {
            let productValue = i.washCount * i.washAveragePercentage
            return productValue
        })
        let sum = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        let percentResult = sum / washCount
        dispatch(previousAvgWashScoreSuccess((round(percentResult, 1))))
    }
    if (data.length === 0) {
        dispatch(previousAvgWashScoreStart())
        dispatch(previousAvgWashScoreSuccess(0))

    }
    else {
        dispatch(previousAvgWashScoreFailure())
    }
}


//get scub time 
const getScrubTime = (dispatch, data, washCount) => {
    if (data.length !== 0) {

        dispatch(avgScrubTimeStart())
        let array = data.map((i) => {
            let productValue = i.washCount * i.averageScrubTime
            return productValue
        })
        let scrubTimeSum = array.reduce(function (x, y) {
            return x + y;
        }, 0);
        dispatch(avgScrubTimeSuccess(scrubTimeSum / washCount))
    }
    if (data.length === 0) {
        dispatch(avgScrubTimeStart())
        dispatch(avgScrubTimeSuccess(0))
    }
}

//get daily machine usage
export const getDailyMachineUsages = async (dispatch, fromDate, toDate, siteMachinesIds, dateCategory) => {
    let resultObject = {}
    let keys = []
    let array = []
    dispatch(dailyMachineUsagesStart())
    if (!fromDate) return

    try {
        const fetchDailyMachineUsagesData = await fetchDailyMachineUsages(`${fromDate}`, `${toDate}`, siteMachinesIds, null, null, true)
        const handSummaryData = await fetchHandsRecognition({ date: `${fromDate}`, fromHour: null, machineIds: siteMachinesIds, toDate: `${toDate}`, toHour: null, })
        if (fetchDailyMachineUsagesData.length !== 0) {
            dispatch(dailyMachineUsagesSuccess(fetchDailyMachineUsagesData))

            for (let i = 0; i < dateCategory.length; i++) {
                const element1 = dateCategory[i];
                let count = 0
                for (let j = 0; j < fetchDailyMachineUsagesData.length; j++) {
                    const element2 = new Date(fetchDailyMachineUsagesData[j].washDate).toISOString().split('T')[0];
                    if (element1 === element2) {
                        count = count + fetchDailyMachineUsagesData[j].washCount
                    }
                }
                if (count > 0) {
                    resultObject[dateCategory[i]] = count;
                    keys = Object.keys(resultObject);
                    array = Object.keys(resultObject).map(function (key) { return resultObject[key]; });

                    if (keys.length > 0 && array.length > 0) {
                        dispatch(loaderSuccess(false))

                    }
                    dispatch(washDatesSuccess(keys))
                    dispatch(washValuesSuccess(array))
                }
            }
            let washCount = getWashCount(dispatch, fetchDailyMachineUsagesData);
            getWashPercentage(dispatch, fetchDailyMachineUsagesData, washCount)
            getScrubTime(dispatch, fetchDailyMachineUsagesData, washCount)
            const { series, xaxis } = countHandsRecognition(handSummaryData)

            if (series.length > 0) {
                dispatch(handWashValuesStart())
                dispatch(handWashValuesSuccess(series))
            }
            if (series.length === 0) {
                dispatch(handWashValuesSuccess([]))

            }

            if (xaxis.length > 0) {
                dispatch(handWashMovementsStart())
                dispatch(handWashMovementsSuccess(xaxis))

            }
            if (xaxis.length === 0) {
                dispatch(handWashMovementsSuccess([]))

            }
        }
        if (fetchDailyMachineUsagesData.length === 0) {
            dispatch(dailyMachineUsagesSuccess([]))
            dispatch(washDatesSuccess([]))
            dispatch(washValuesSuccess([]))
            dispatch(handWashValuesStart())
            dispatch(handWashValuesSuccess([]))
            dispatch(handWashMovementsStart())
            dispatch(handWashMovementsSuccess([]))
            dispatch(totalWashCountSuccess(0))
            dispatch(avgWashScoreSuccess(0))
            dispatch(avgScrubTimeSuccess(0))

            dispatch(loaderSuccess(false))

        }


    } catch (error) {
        console.log(error);
        dispatch(dailyMachineUsagesFailure())
        dispatch(handWashValuesFailure())
        dispatch(handWashMovementsFailure())

        dispatch(avgScrubTimeFailure())
        dispatch(avgWashScoreFailure())

    }
}


//get current daily machine usage
export const getCurrentDailyMachineUsages = async (dispatch, currentFrom, currentTo, siteMachinesIds, minWashCnt) => {
    try {
        dispatch(currentShiftResultsStart())
        let fromDate = new Date(currentFrom).toISOString()
        let toDate = new Date(currentTo).toISOString()


        const fetchDailyMachineUsagesData = await fetchDailyMachineUsages(fromDate, toDate, siteMachinesIds, false)
        if (fetchDailyMachineUsagesData.length !== 0) {
            dispatch(currentShiftResultsSuccess(fetchDailyMachineUsagesData))
            let washCount = currentShiftWashCount(dispatch, fetchDailyMachineUsagesData);

            currentShiftWashPercentage(dispatch, fetchDailyMachineUsagesData, washCount)
            currentShiftFailedWashCount(dispatch, fetchDailyMachineUsagesData)
            dispatch(currentWashLeftSuccessAuto({ minWashCnt, washCount }))

        }
        if (fetchDailyMachineUsagesData.length === 0) {
            let washCount = 0
            dispatch(currentShiftResultsSuccess([]))
            dispatch(currentWashCountSuccess(0))
            dispatch(currentAvgWashScoreSuccess(0))
            dispatch(currentFailedCountSuccess(0))
            dispatch(currentWashLeftSuccessAuto({ minWashCnt, washCount }))

        }

    } catch (error) {
        console.log(error);
        dispatch(currentShiftResultsFailure())

    }
}



//get previous daily machine usage
export const getPreviousDailyMachineUsages = async (dispatch, previousFrom, previousTo, siteMachinesIds, minWashCnt) => {

    try {
        dispatch(previousShiftResultsStart())
        let fromDate = new Date(previousFrom).toISOString()
        let toDate = new Date(previousTo).toISOString()

        const fetchDailyMachineUsagesData = await fetchDailyMachineUsages(fromDate, toDate, siteMachinesIds, false)

        if (fetchDailyMachineUsagesData.length !== 0) {
            dispatch(previousShiftResultsSuccess(fetchDailyMachineUsagesData))
            let washCount = previousShiftWashCount(dispatch, fetchDailyMachineUsagesData);

            previousShiftWashPercentage(dispatch, fetchDailyMachineUsagesData, washCount)
            previousShiftFailedWashCount(dispatch, fetchDailyMachineUsagesData)
            dispatch(previousWashLeftSuccessAuto({ minWashCnt, washCount }))

        }
        if (fetchDailyMachineUsagesData.length === 0) {
            let washCount = 0
            dispatch(previousShiftResultsSuccess([]))
            dispatch(previousWashCountSuccess(0))
            dispatch(previousAvgWashScoreSuccess(0))
            dispatch(previousFailedCountSuccess(0))
            dispatch(previousWashLeftSuccessAuto({ minWashCnt, washCount }))
        }

    } catch (error) {
        console.log(error);
        dispatch(previousShiftResultsFailure())

    }
}

//count hands recognition
const countHandsRecognition = (data) => {
    const handsRecognitionKeys = Object.values(HANDS_RECOGNITION_KEYS)
    const resultObject = {}
    const successSeriesData = []
    const failedSeriesData = []
    const xaxis = []

    handsRecognitionKeys.forEach(key => {
        resultObject[key] = []
    })

    data.forEach(item => {
        handsRecognitionKeys.forEach(key => {
            const value = item[key]
            if (value !== null) {
                resultObject[key].push(value)
            }
        })
    })

    handsRecognitionKeys.forEach(key => {
        const countSuccess = resultObject[key].filter(Boolean).length
        xaxis.push(HANDS_ICON_NAMES_LOWERCASE[key])
        // null is better than 0, because 0 values are not pretty in the chart
        successSeriesData.push(countSuccess || null)
        failedSeriesData.push((resultObject[key].length - countSuccess) || null)
    })

    return {
        xaxis,
        series: [
            {
                data: successSeriesData,
                name: 'Success'
            },
            {
                data: failedSeriesData,
                name: 'Failed'
            }
        ]
    }
}



//get champions
export const getChampionsList = async (dispatch, currentSitesIdsArray, fromDate, toDate) => {
    console.log({ currentSitesIdsArray, fromDate, toDate });
    if (!fromDate) return
    // let siteIdArray = [];
    // siteIdArray.push(currentSiteId);
    dispatch(championsStart())
    try {
        let championsData = await fetchChampionsResults(currentSitesIdsArray, fromDate, toDate)
        if (championsData.length > 10) {
            dispatch(championsSuccess(championsData.slice(0, 10)))
        }
        if (championsData.length <= 10) {
            dispatch(championsSuccess(championsData))
        }
        if (championsData.length === 0) {
            dispatch(championsSuccess([]))
        }
    } catch (error) {
        console.log(error);
        dispatch(championsFailure())

    }
}


//get previous champion
export const getPreviousChampion = async (dispatch, currentSitesIdsArray, fromDate, toDate) => {

    if (!fromDate) return
    dispatch(previousChampionStart())
    try {
        let championsData = await fetchChampionsResults(currentSitesIdsArray, fromDate, toDate)
        if (championsData.length > 0) {
            dispatch(previousChampionSuccess(championsData[0]))
        }
        if (championsData.length === 0) {
            dispatch(previousChampionSuccess(null))
        }

    } catch (error) {
        console.log(error);
        dispatch(previousChampionFailure())

    }
}


//get current champion
export const getCurrentChampion = async (dispatch, currentSitesIdsArray, fromDate, toDate) => {

    if (!fromDate) return
    dispatch(currentChampionStart())
    try {
        let championsData = await fetchChampionsResults(currentSitesIdsArray, fromDate, toDate)
        if (championsData.length > 0) {
            dispatch(currentChampionSuccess(championsData[0]))
        }
        if (championsData.length === 0) {
            dispatch(currentChampionSuccess(null))
        }

    } catch (error) {
        console.log(error);
        dispatch(currentChampionFailure())

    }
}


//get shift configuration images
export const getShiftConfigurationImages = async (dispatch, currentOrganizationId) => {
    dispatch(autoRefreshTimeStart())
    try {
        const { clientLogo, importantUpdateImage, autoRefreshTime } = await fetchShiftConfiguration(currentOrganizationId)
        dispatch(autoRefreshTimeSuccess(autoRefreshTime))
        dispatch(clientLogoSuccess(clientLogo))
        dispatch(importantImageUploadSuccess(importantUpdateImage))
    } catch (error) {
        console.log(error);
        dispatch(autoRefreshTimeFailure())
    }
}

//create and update shiftConfiguration
export const shiftConfiguration = async (dispatch, config, setShiftConfigurationData, setLoading) => {
    dispatch(shiftConfigurationDataStart())
    try {
        const shiftConfigurationResponse = await createShiftConfiguration(config)
        setShiftConfigurationData(shiftConfigurationResponse)
        dispatch(shiftConfigurationDataSuccess(shiftConfigurationResponse))
        dispatch(autoRefreshTimeSuccess(shiftConfigurationResponse.autoRefreshTime))
        if (shiftConfigurationResponse) {
            setLoading(false)
        }
    } catch (error) {
        dispatch(shiftConfigurationDataFailure())
        console.log(error);
    }
}


//get shift configuration 
export const getShiftConfiguration = async (dispatch, setShiftConfigurationData, setLoading) => {
    try {
        const shiftResponse = await fetchShiftConfiguration()
        if (Object.keys(shiftResponse).length > 0) {
            const { data, shiftData, washDates, washValues, series, xaxis, champions } = shiftResponse
            setShiftConfigurationData({ ...data, ...shiftData, washDates, washValues, series, xaxis, champions })
            dispatch(shiftConfigurationDataSuccess({ ...data, ...shiftData, washDates, washValues, series, xaxis, champions }))
            dispatch(autoRefreshTimeSuccess(data.autoRefreshTime))
        }
        else {
            setShiftConfigurationData(null)
            dispatch(shiftConfigurationDataSuccess(null))
            dispatch(autoRefreshTimeSuccess(5))
        }
        setLoading(false)
    } catch (error) {
        console.log(error);
    }
}


//get daily washes for multiple machines
export const getDailyWashesMultiMachines = async (dispatch, fromDate, toDate, machineIds, setLoader, setTemperatureThreshold) => {
    dispatch(dailyWashesStart())
    try {
        const { dailyWashes, temperatureThreshold } = await fetchDailyWashesMultiMachines(fromDate, toDate, machineIds)
        if (dailyWashes.error) {
            dispatch(dailyWashesFailure())
            setLoader(false)
            return
        }
        dispatch(dailyWashesSuccess(dailyWashes))
        setTemperatureThreshold(temperatureThreshold)
        setLoader(false)
    } catch (error) {
        dispatch(dailyWashesFailure())
        setLoader(false)
    }
}


//get daily machine usage on trends page
export const getTrendsDailyMachineUsages = async (fromDate, toDate, siteMachinesIds, setDailyMachineUsages, setHandRecognitionData, setLoader) => {

    try {
        const fetchDailyMachineUsagesData = await fetchDailyMachineUsages(`${fromDate}`, `${toDate}`, siteMachinesIds, null, null, true)
        const handSummaryData = await fetchHandsRecognition({ date: `${fromDate}`, fromHour: null, machineIds: siteMachinesIds, toDate: `${toDate}`, toHour: null, })

        setDailyMachineUsages(fetchDailyMachineUsagesData)
        setHandRecognitionData(handSummaryData)
        setLoader(false)
    } catch (error) {
        console.log(error);
    }
}

//fetch reportVersion
export const fetchReportVersion = async (setReportVersion) => {
    const { version } = await getReportVersion()
    setReportVersion(version)
}



